import { render, staticRenderFns } from "./AppAdDetail.vue?vue&type=template&id=22c29203&scoped=true&"
import script from "./AppAdDetail.vue?vue&type=script&lang=js&"
export * from "./AppAdDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c29203",
  null
  
)

export default component.exports